import { render, staticRenderFns } from "./Credito.vue?vue&type=template&id=461f1c98&scoped=true"
import script from "./Credito.vue?vue&type=script&lang=js"
export * from "./Credito.vue?vue&type=script&lang=js"
import style0 from "./Credito.vue?vue&type=style&index=0&id=461f1c98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461f1c98",
  null
  
)

export default component.exports